module.exports = __webpack_public_path__ + "img/mgm-pc.751eb362.png";